export const Google = ({ className = "w-5 h-5" }) => {
  return (
    <svg className={className} viewBox="0 0 24 24">
      <path
        fill="#4285F4"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      />
    </svg>
  );
};

export const Apple = ({ className = "w-5 h-5" }) => {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor">
      <path d="M14.94 5.19A4.38 4.38 0 0 0 16 2.94a4.44 4.44 0 0 0-2.87 1.51 4.09 4.09 0 0 0-1.12 2.94 3.61 3.61 0 0 0 2.93-1.2z" />
      <path d="M19.52 12.28a5.67 5.67 0 0 0 2.62-4.67 5.82 5.82 0 0 0-4.21 2.11 5.36 5.36 0 0 0 1.59 2.56z" />
      <path d="M16.23 15.32A8.09 8.09 0 0 1 12.5 17a8.09 8.09 0 0 1-3.73-1.68c-2.52-1.84-4.17-4.67-4.17-7.66 0-3.09 1.5-5.83 3.73-7.66A9.87 9.87 0 0 0 6.42 0C3.98 0 1.81 1.91 1.81 4.77c0 2.86 1.6 5.66 3.85 7.45A10.56 10.56 0 0 0 11.77 16a7.61 7.61 0 0 0 4.46-2.68z" />
      <path d="M22 16.92a8.68 8.68 0 0 1-2.13 2.93 10.93 10.93 0 0 1-2.51 1.83 12.07 12.07 0 0 1-2.44 1.06 10.86 10.86 0 0 1-2.62.32 8.47 8.47 0 0 1-1.57-.15 6.76 6.76 0 0 1-1.94-.72 9.58 9.58 0 0 1-1.51-1 7.48 7.48 0 0 1-1.09-1.18 9.43 9.43 0 0 0 3.43 1.94 7.15 7.15 0 0 0 3.73.33 6.53 6.53 0 0 0 2.88-1.22 5.76 5.76 0 0 0 1.91-2.41 5.51 5.51 0 0 0 .54-2.57 5.57 5.57 0 0 0-.86-2.92z" />
    </svg>
  );
};

export const Whatsapp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#25D366">
      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
    </svg>
  );
};
